export default {
  loadFailed: '加载失败',
  loading: '加载中'
};